import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
const useStyles = makeStyles(({ spacing }) => createStyles({
    prefixLg: {
        paddingRight: spacing(3),
    },
    proLg: {
        paddingLeft: spacing(1.5),
    },
    fatLg: {
        paddingLeft: spacing(1.5),
    },
    prefixSm: {
        paddingRight: spacing(1),
    },
    proSm: {
        paddingLeft: spacing(1),
    },
    fatSm: {
        paddingLeft: spacing(1),
    },
    xs: {
        fontSize: ".6rem",
    },
}));
export const MacrosSummaryLabel = ({ macros: { cho, pro, fat, kcal }, prefix, variant, kcalPrefix = false, sx }) => {
    const classes = useStyles();
    const prefixText = prefix ? prefix : kcalPrefix ? `${Math.round(kcal)}kcal ` : undefined;
    return (_jsxs(Typography, { variant: variant === "lg" ? "body1" : "body2", classes: variant === "xs" ? { root: classes.xs } : {}, color: "inherit", sx: sx, children: [prefixText && _jsx("span", { className: variant === "lg" ? classes.prefixLg : classes.prefixSm, children: prefixText }), _jsx(Box, { component: "span", sx: { color: "cho.main" }, children: "CHO" }), ": ", Math.round(cho), "g", _jsx(Box, { component: "span", sx: { color: "pro.main" }, className: variant === "lg" ? classes.proLg : classes.proSm, children: "PRO" }), ": ", Math.round(pro), "g", _jsx(Box, { component: "span", sx: { color: "fat.main" }, className: variant === "lg" ? classes.fatLg : classes.fatSm, children: "FAT" }), ": ", Math.round(fat), "g"] }));
};
//# sourceMappingURL=SummaryLabel.js.map